export const GET_OFFERS_PROMPTS = 'GET_OFFERS_PROMPTS';

export function getOffersPrompt(callback) {
  return {
    type: GET_OFFERS_PROMPTS,
    callback,
  };
}
